import { Request } from 'express';
import { ReactElement } from 'react';
import { TrackPageViewContainer } from '../../../common/containers/TrackPageViewContainer';
import { getDehydratedState } from '../../../common/getDehydrateState';
import { t, tt } from '../../../common/getTranslations';
import { Layout } from '../../../design-system/layout/Layout';
import PageLayout from '../../../domain/landing/presentational';
import { ApiErrorBoundary } from '../../../errors/ApiErrorBoundary.class';
import { addError } from '../../../errors/ErrorSlice';
import { thunkSerializeError } from '../../../errors/thunkSerializeError.function';
import { StaticLandingOriginalLayoutQuery, StaticLandingOriginalLayoutQueryVariables, StaticLandingOriginalSection, StaticLandingType } from '../../../graphql/generated/types';
import { CommonMobileHeaderType } from '../../../header/constants';
import { PageViewCustomPropsDataKey } from '../../../logging/PageViewCustomPropsDataKey.enum';
import { setLayout } from '../../../pagewebLayout/PagewebLayoutSlice';
import { nextReduxWrapper } from '../../../state/store';
import { STATIC_LANDING_PAGE_NAME_MAP, STATIC_LANDING_PAGE_SECTION_NAME } from '../../../staticLanding/constants';
import { STATIC_LANDING_ORIGINAL_CATEGORY_LIST } from '../../../staticLanding/original/constants';
import { queryStaticLandingLayout } from '../../../staticLanding/queryStaticLandingLayout';
function StaticLandingOriginal({
  layoutId
}: {
  layoutId: string;
}) {
  return <>
      <ApiErrorBoundary>
        <PageLayout id={layoutId} />
      </ApiErrorBoundary>
      <TrackPageViewContainer trackObj={{
      section: STATIC_LANDING_PAGE_SECTION_NAME,
      page: STATIC_LANDING_PAGE_NAME_MAP[StaticLandingType.Original],
      actionType: 'Pageview',
      actionName: `${STATIC_LANDING_PAGE_NAME_MAP[StaticLandingType.Original]}_화면`,
      customProps: {
        user_action: 'pv'
      }
    }} customPropsDataKeyList={[PageViewCustomPropsDataKey.PageCategoryFilter, PageViewCustomPropsDataKey.PageGenreFilter, PageViewCustomPropsDataKey.PageSort, PageViewCustomPropsDataKey.Completed]} />
    </>;
}
StaticLandingOriginal.getInitialProps = nextReduxWrapper.getInitialPageProps(store => async context => {
  const cookie = context?.req?.headers.cookie;
  const uidInfoList = context.query?.pathParams as string[];
  const query = context?.query;
  if (!uidInfoList || uidInfoList.length === 0) {
    return {
      notFound: true
    };
  }
  try {
    const {
      data,
      queryClient
    } = await queryStaticLandingLayout<StaticLandingOriginalLayoutQuery, StaticLandingOriginalLayoutQueryVariables>({
      ssrRequest: context.req as Request,
      type: StaticLandingType.Original,
      cookie,
      uidInfoList,
      query
    });
    if (!data || !data.staticLandingOriginalLayout) {
      throw new Error('오리지널 레이아웃 데이터가 없습니다.');
    }
    const layoutId = data.staticLandingOriginalLayout.id;
    // redux에 레이아웃 정보가 없을 때만 setLayout으로 값을 초기화 해줍니다.
    if (!store.getState().pagewebLayout.entities.layouts[layoutId]) {
      store.dispatch(setLayout({
        layout: data.staticLandingOriginalLayout
      }));
    }
    const staticLandingOriginalSection = data.staticLandingOriginalLayout.sections[0] as StaticLandingOriginalSection;
    const categoryUid = staticLandingOriginalSection.param.categoryUid;
    const category = STATIC_LANDING_ORIGINAL_CATEGORY_LIST.find(categoryInfo => categoryInfo.id === categoryUid);
    return {
      layoutId,
      categoryName: tt(category),
      subcategoryName: staticLandingOriginalSection.param.subcategory?.name,
      sortTypeName: staticLandingOriginalSection.param.sortType?.name,
      isComplete: staticLandingOriginalSection.param.isComplete ? 'y' : 'n',
      ...getDehydratedState(queryClient)
    };
  } catch (error) {
    store.dispatch(addError({
      error: thunkSerializeError(error)
    }));
    return {};
  }
});
StaticLandingOriginal.getLayout = function getLayout(page: ReactElement) {
  const {
    categoryName,
    subcategoryName,
    sortTypeName,
    isComplete
  } = page.props;
  return <Layout title={t('landing_original')} mobileLayoutConfig={{
    shouldShowHeader: true,
    shouldShowFooter: true,
    headerType: CommonMobileHeaderType.TwoDepth,
    headerCustomTiaraObject: {
      customProps: {
        page_category_filter: categoryName,
        page_genre_filter: subcategoryName,
        page_sort: sortTypeName,
        completed: isComplete
      }
    }
  }} pcLayoutConfig={{
    shouldShowHeader: true,
    shouldShowFooter: true
  }}>
      {page}
    </Layout>;
};
export default StaticLandingOriginal;